import { Control } from 'react-hook-form';
import { IoAddOutline } from 'react-icons/io5';
import { Button } from '@/components/atoms/Button';
import SubtitleText from '@/components/atoms/SubtitleText';
import { ApprovalFlowFormData } from '../types';
import { ApproverItem } from './ApproverItem';

interface ApprovalStepProps {
	stepIndex: number;
	stepNumber: number;
	control: Control<ApprovalFlowFormData>;
	approvers: number[];
	onAddApprover: () => void;
	onRemoveApprover: (approverIndex: number) => void;
	onRemoveLevel: () => void;
}

export const ApprovalStep = ({
	stepIndex,
	stepNumber,
	control,
	approvers,
	onAddApprover,
	onRemoveApprover,
	onRemoveLevel,
}: ApprovalStepProps) => {
	return (
		<div className="border border-[#CBD5E1] p-[10px] pt-[4px] rounded-[6px] flex flex-col gap-2">
			<div className="flex justify-between items-center">
				<SubtitleText subtitle={`Nível ${stepNumber}`} />
				<Button type="button" variant={'secondary'} onClick={onRemoveLevel}>
					Remover nível
				</Button>
			</div>
			{(approvers || []).map((approver, approverIndex) => (
				<ApproverItem
					key={`approver-${approver}`}
					stepIndex={stepIndex}
					approverIndex={approverIndex}
					control={control}
					onRemove={() => onRemoveApprover(approverIndex)}
				/>
			))}
			<Button
				type="button"
				variant={'secondary'}
				onClick={onAddApprover}
				className="w-[11rem] pl-0 h-8"
			>
				<IoAddOutline size={16} />
				Adicionar colaborador
			</Button>
		</div>
	);
};
